require('../../../src/stylus/components/_grid.styl');

import Grid from './grid';

export default Grid('flex');


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/components/VGrid/VFlex.js
// module id = Mlxr
// module chunks = 0